import { createAction } from '@reduxjs/toolkit';
import { Calendar, FetchCalendarProps } from 'lib/clients/fetchCalendar';

export const fetchCalendar = createAction<FetchCalendarProps>('calendar/FETCH_CALENDAR');
export const fetchCalendarByOffer = createAction('calendar/FETCH_CALENDAR_BY_ROOMTYPE'); // UNUSED
export const fetchCalendarFailure = createAction('calendar/FETCH_CALENDAR_FAILURE'); // UNUSED
export const setCalendar = createAction<Calendar>('calendar/SET_CALENDAR');
export const clearCalendar = createAction('calendar/CLEAR_CALENDAR');
